var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsLeftAndRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.53214 2.84633C5.82551 2.53834 5.82551 2.03898 5.53214 1.73099C5.23876 1.423 4.76309 1.423 4.46972 1.73099L0.220035 6.19233C-0.073345 6.50032 -0.0733447 6.99968 0.220035 7.30767L4.46972 11.769C4.76309 12.077 5.23876 12.077 5.53214 11.769C5.82551 11.461 5.82552 10.9617 5.53214 10.6537L2.51154 7.48264H23.2488C23.6637 7.48264 24 7.12954 24 6.69397C24 6.25841 23.6637 5.90531 23.2488 5.90531L2.61828 5.90531L5.53214 2.84633ZM18.4679 21.1537C18.1745 21.4617 18.1745 21.961 18.4679 22.269C18.7612 22.577 19.2369 22.577 19.5303 22.269L23.78 17.8077C24.0733 17.4997 24.0733 17.0003 23.78 16.6923L19.5303 12.231C19.2369 11.923 18.7612 11.923 18.4679 12.231C18.1745 12.539 18.1745 13.0383 18.4679 13.3463L21.4885 16.5174H0.751245C0.336344 16.5174 0 16.8705 0 17.306C0 17.7416 0.336343 18.0947 0.751245 18.0947L21.3817 18.0947L18.4679 21.1537Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsLeftAndRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrows-left-and-right.c6dbf28e84f0213186a1947011b05c75.svg";